module.exports = __webpack_public_path__ + "assets/img/6.036da4bf.jpg";